module.exports = __webpack_public_path__ + "media/images/landing_page/peteris_un_sandra_1-f4d6f695a220d92abdaec74c81cb29f3.jpg";